module.exports = __webpack_public_path__ + "img/stock-2.5d915e87.jpg";